export default {"src":"/_next/static/media/left.716011ea.svg","height":242,"width":93,"blurWidth":0,"blurHeight":0};